import {
    START_FETCHING_PRINT_RECORD_SHARING_STATUS,
    RECEIVED_PRINT_RECORD_SHARING_STATUS,
    START_TOGGLE_PRINT_RECORD_SHARING,
    TOGGLE_PRINT_RECORD_SHARING_SUCCESSFULLY,
    TOGGLE_PRINT_RECORD_SHARING_FAILED
} from "../actions/types";
import { PRINT_RECORD_SHARING_STATUS } from "../containers/account-setting-container";
const initState = {
    printRecordSharingStatus: PRINT_RECORD_SHARING_STATUS.OFF,
    printRecordSharingToggleable: true
}

const printRecordSharingReducer = (state = initState, action) => {
    const { type, payload } = action;
    switch (type) {
        case START_FETCHING_PRINT_RECORD_SHARING_STATUS:
          return { ...state, printRecordSharingToggleable: false };
        case RECEIVED_PRINT_RECORD_SHARING_STATUS:
          return { ...state, printRecordSharingToggleable: true, printRecordSharingStatus: payload.printRecordSharingStatus}
        case START_TOGGLE_PRINT_RECORD_SHARING:
          return { ...state, printRecordSharingToggleable: false };
        case TOGGLE_PRINT_RECORD_SHARING_SUCCESSFULLY:
          return { ...state, printRecordSharingToggleable: true, printRecordSharingStatus: payload.printRecordSharingStatus}
        case TOGGLE_PRINT_RECORD_SHARING_FAILED:
          return { ...state, printRecordSharingToggleable: true};
        default:
          return state;
    }
}

export default printRecordSharingReducer;



// WEBPACK FOOTER //
// ./src/reducers/print-record-sharing-reducer.js